import { BaseApi } from './base';

class StudyingLessonsApi extends BaseApi {
  constructor() {
    super('admin/program/lessons');
  }

  getLessons() {
    return this.get('')
  }

  createOrUpdateLesson(data) {
    return this.post('', data)
  }

  removeLesson(id) {
   return this.delete(`/${id}`)
  }

  getClassWorks() {
    return this.get('/classwork-files')
  }

  getHomeWorks() {
    return this.get('/homework-files')
  }

  createClassWork(data) {
    return this.post('/classwork-files', data)
  }

  createHomeWork(data) {
    return this.post('/homework-files', data)
  }

}

export default new StudyingLessonsApi();
